import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import trash from "../../../src/assests/images/trash.svg";
import plus from "../../../src/assests/images/plus_red.svg";
import cancel from "../../../src/assests/images/close-circle.svg";
import galleryadd from "../../../src/assests/images/gallery-add.svg";
import Fileupload from "../FileuploadWithPreview/Fileupload";
import { useTaskContext } from "../store/AlltasksContext";
import { uploadimagetask } from "../../pages/create-task/api";
import { getToken } from "../../utils/utils";

// interface InstructionItem {
//   id: number;
//   value: string;
//   value_hi: string;
//   smallimage: string;
//   bigimage: string;
//   image?: string;
//   hint_id?:string
//   primarykeyid
// }
interface InstructionItem {
  id: number;
  value: string;
  value_hi: string;
  smallimage: string;
  bigimage: string;
  hint_id?: string | number;      // add this
  primarykeyid?: string | number; // add this
  image?: string;
}


interface MulitipleItem {
  id: number;
  value: string;
  checkvalue: string;
  smallimage: string;
  bigimage: string;
}

interface InstructionProps {
  initialInstructions?: InstructionItem[];
  placeholderPrefix?: string;
  containerClassName?: string;
  idid: number;
  textvalue: string;
  multiples: MulitipleItem[];
  selectedValue: string | null;
  text: string;
  sectionsData1: string;
  selectedLabel: string | null;
  updateSectionsData2: (sectionId: number, selectedLabel: string | null) => void;
  lang: {
    addInstruction: string;
  };
}

interface SectionData {
  id: number;
  initialName: string;
  placeholder: string;
  markerImage: string;
  typographyText: string;
  textValue: string;
  textValue_hi: string;
  language: string;
    main_question_id: string;
  iconimage: string;
  mainplaceholder: string;
  selectValue: string;
  smallquestionsimage: string[];
  optionsslectedvalue: string | null;
  finalcorr?: string;
  correcthint: string;
  correcthint_hi: string;
  idid1: number;
  taskinstructions: { id: number; value: string; image: string }[];
  taskimage: string;
  test245: string;
  dropdownOptions: { id: number; label: string; value: string }[];
  instructions: { id: number; value: string; value_hi: string; smallimage: string; bigimage: string; hint_id?: string | number; primarykeyid?: string | number; }[];
  Multiples: { id: number; value: string; value_hi: string; checkvalue: string; smallimage: string; bigimage: string; ismatch?: boolean }[];
  Checkboxes: { id: number; value: string; checked: boolean }[];
  rating: { initialStars: number; maxStarsOptions: number[] };
  longShortDescription?: { long?: string; long_hi?: string };
}

const InstructionOne: React.FC<InstructionProps> = ({
  initialInstructions = [{ id: 1, value: "", image: "" }],
  placeholderPrefix = "Instruction",
  containerClassName = "inst-box",
  idid,
  textvalue,
  multiples,
  selectedLabel,
  updateSectionsData2,
  selectedValue,
  text,
  sectionsData1,
  lang,
}) => {
  const { sectionsData, setSectionsData, educationalData, seteducationalData, activeStep, instructionImageMap, setInstructionImageMap, Tabname, setValueArray, setValueHiArray, valueHiArray, valueArray } = useTaskContext();
  const [imageMap, setImageMap] = useState<Record<number, { url: string; type: "bigimage" | "smallimage" }[]>>({});
  const draggedItem = useRef<number | null>(null);

  const [currentData, setCurrentData] = useMemo<
    [SectionData[], React.Dispatch<React.SetStateAction<SectionData[]>>]
  >(() => {
    return (
     Tabname === "Educational task" ||
      Tabname === "शैक्षिक कार्य" ||
      Tabname === "शैक्षणिक कार्य" ||
      Tabname === "Survey Task" ||
      Tabname === "सर्वेक्षण" ||
      Tabname === "Feedback Task" ||
      Tabname === "प्रतिक्रिया"
    )
      ? [educationalData as SectionData[], seteducationalData]
      : [sectionsData as SectionData[], setSectionsData];
  }, [Tabname, sectionsData, setSectionsData, educationalData, seteducationalData]);

  // Automatically populate instructions and valueHiArray in activeStep === 2 based on valueArray
 useEffect(() => {
    const valueArrayForSection = valueArray.filter((v) => v.mainid === idid);
    const valueHiArrayForSection = valueHiArray.filter((v) => v.mainid === idid);
    const instructionsLength = Math.max(valueArrayForSection.length, 1);

const prepopulatedInstructions = Array.from({ length: instructionsLength }, (_, index) => {
  const enItem = valueArrayForSection.find((v) => v.index === index + 1);
  const hiItem = valueHiArrayForSection.find((v) => v.index === index + 1);
  return {
    id: index + 1,
    value: enItem?.value || "",
    value_hi: hiItem?.value || "",
    hint_id: enItem?.hint_id || hiItem?.hint_id || "",
    smallimage: "",
    bigimage: "",
     primarykeyid: enItem?.primarykeyid || hiItem?.primarykeyid || 0
  };
});


    setCurrentData((prevState) => {
      const sectionExists = prevState.find((item) => item.id === idid);

      if (!sectionExists) {
        return [
          ...prevState,
          {
            id: idid,
            initialName: "",
            placeholder: "",
            markerImage: "",
            typographyText: "",
            textValue: "",
            textValue_hi: "",
            language: "",
              main_question_id: "",
            iconimage: "",
            mainplaceholder: "",
            selectValue: "instructions",
            smallquestionsimage: [],
            optionsslectedvalue: null,
            finalcorr: "",
            correcthint: "",
            correcthint_hi: "",
            idid1: 0,
            taskinstructions: [],
            taskimage: "",
            test245: "",
            dropdownOptions: [],
            instructions: prepopulatedInstructions,
            Multiples: [],
            Checkboxes: [],
            rating: { initialStars: 0, maxStarsOptions: [5, 6, 7, 8, 9, 10] },
            longShortDescription: { long: "", long_hi: "" },
          },
        ];
      }

      return prevState.map((item) =>
        item.id === idid ? { ...item, instructions: prepopulatedInstructions } : item
      );
    });
  }, [activeStep, idid, valueArray, valueHiArray, setCurrentData]);
// remove setCurrentData and setValueHiArray from deps

  useEffect(() => {
    console.log("currentData:", currentData);
    console.log("Section with idid:", currentData.find((item) => item.id === idid));
  }, [currentData, idid]);

  const prevMultiplesRef2 = useRef(selectedLabel);
  useEffect(() => {
    if (JSON.stringify(prevMultiplesRef2.current) !== JSON.stringify(selectedLabel)) {
      updateSectionsData2(idid, selectedLabel);
      prevMultiplesRef2.current = selectedLabel;
    }
  }, [selectedLabel, idid, updateSectionsData2]);

  const prevMultiplesRef1 = useRef(text);

  const addInstruction = (idid: number) => {
    console.log(idid, "ididsssss7777");
    setCurrentData((prevState: SectionData[]) => {
      const sectionExists = prevState.find((item) => item.id === idid);

      if (!sectionExists) {
        console.warn(`Section with id ${idid} not found in currentData`);
        return [
          ...prevState,
          {
            id: idid,
            initialName: "",
            placeholder: "",
            markerImage: "",
            typographyText: "",
            textValue: "",
            textValue_hi: "",
            language: "",
              main_question_id: "",
            iconimage: "",
            mainplaceholder: "",
            selectValue: "instructions",
            smallquestionsimage: [],
            optionsslectedvalue: null,
            finalcorr: "",
            correcthint: "",
            correcthint_hi: "",
            idid1: 0,
            taskinstructions: [],
            taskimage: "",
            test245: "",
            dropdownOptions: [],
            instructions: [
              {
                id: 1,
                value: "",
                smallimage: "",
                value_hi: "",
                bigimage: "",
              },
            ],
            Multiples: [],
            Checkboxes: [],
            rating: { initialStars: 0, maxStarsOptions: [5, 6, 7, 8, 9, 10] },
            longShortDescription: { long: "", long_hi: "" },
          },
        ];
      }

      return prevState.map((item) =>
        item.id === idid
          ? {
              ...item,
              instructions: [
                ...item.instructions,
                {
                  id: item.instructions.length
                    ? Math.max(...item.instructions.map((inst) => inst.id)) + 1
                    : 1,
                  value: "",
                  smallimage: "",
                  value_hi: "",
                  bigimage: "",
                },
              ],
            }
          : item
      );
    });
  };

  const removeInstruction = (id: number) => {
    setCurrentData((prevState) =>
      prevState.map((item) =>
        item.id === idid
          ? { ...item, instructions: item.instructions.filter((inst) => inst.id !== id) }
          : item
      )
    );

    setImageMap((prev) => {
      const updatedImages = { ...prev };
      delete updatedImages[id];
      return updatedImages;
    });
  };

const handleInputChange = (mainid: number, index: number, value: string) => {
  if (activeStep === 1) {
    // 🟢 Get the old English value before updating
    const oldValue = valueArray.find((v) => v.mainid === mainid && v.index === index)?.value || "";

    // 🟢 Update English array
    setValueArray((prev) => {
      const filtered = prev.filter(
        (item) => !(item.mainid === mainid && item.index === index)
      );
      return [...filtered, { mainid, index, value, hint_id: "", primarykeyid: 0 }];
    });

    // 🟢 Auto-sync full value into Hindi array (not partial)
    setValueHiArray((prev) => {
      const filtered = prev.filter(
        (item) => !(item.mainid === mainid && item.index === index)
      );

      // Check if Hindi already has manual value
      const existing = prev.find(
        (item) => item.mainid === mainid && item.index === index
      );

      // Only overwrite Hindi if it’s empty or matches the old English
      if (!existing || existing.value.trim() === "" || existing.value === oldValue) {
        return [...filtered, { mainid, index, value, hint_id: "", primarykeyid: 0 }];
      }

      // Otherwise, keep existing Hindi text (user manually changed it)
      return prev;
    });

    // 🟢 Update UI instructions English
    setCurrentData((prev) =>
      prev.map((section) =>
        section.id === mainid
          ? {
              ...section,
              instructions: section.instructions.map((inst) =>
                inst.id === index ? { ...inst, value } : inst
              ),
            }
          : section
      )
    );
  } else if (activeStep === 2) {
    // 🟢 Update Hindi array manually
    setValueHiArray((prev) => {
      const filtered = prev.filter(
        (item) => !(item.mainid === mainid && item.index === index)
      );
      return [...filtered, { mainid, index, value, hint_id: "", primarykeyid: 0 }];
    });

    // 🟢 Update Hindi in currentData
    setCurrentData((prev) =>
      prev.map((section) =>
        section.id === mainid
          ? {
              ...section,
              instructions: section.instructions.map((inst) =>
                inst.id === index ? { ...inst, value_hi: value } : inst
              ),
            }
          : section
      )
    );
  }
};



  const token = getToken();

  const handleImageUpload = async (
    id: number,
    files: FileList | null,
    token: string,
    imageType: "smallimage" | "bigimage"
  ) => {
    if (files && files.length > 0) {
      const formData = new FormData();
      Array.from(files).forEach((file) => formData.append("answer", file));

      try {
        const response = await uploadimagetask(formData, token);
        const uploadedFileName = response.data.answer;
        const imageUrl = response.data.answer;

        setImageMap((prev) => {
          const updatedImages = prev[id] ? [...prev[id], { url: imageUrl, type: imageType }] : [{ url: imageUrl, type: imageType }];
          updateSectionsData(id, imageType, imageUrl);
          return { ...prev, [id]: updatedImages };
        });
      } catch (error) {
        console.error("Error uploading images:", error);
      }
    } else {
      console.log("No files provided for upload.");
    }
  };

  const updateSectionsData = (
    id: number,
    imageType: "smallimage" | "bigimage",
    imageUrl: string,
    isDelete = false
  ) => {
    console.log(id, "Updating:", isDelete, "Deleting?", imageUrl, imageType, "imageTypeimageType");

    setCurrentData((prevState) =>
      prevState.map((item) =>
        item.instructions.some((inst) => inst.id === id)
          ? {
              ...item,
              instructions: item.instructions.map((inst) =>
                inst.id === id
                  ? {
                      ...inst,
                      [imageType]: isDelete
                        ? inst[imageType].split(",").filter((img) => img !== imageUrl).join(",") || ""
                        : inst[imageType] ? `${inst[imageType]},${imageUrl}` : imageUrl,
                    }
                  : inst
              ),
            }
          : item
      )
    );
  };

  const handleDragStart = (index: number) => {
    draggedItem.current = index;
  };

  const handleDrop = (targetIndex: number) => {
    if (draggedItem.current === null) return;

    const section = currentData.find((item) => item.id === idid);
    if (!section || !section.instructions[draggedItem.current] || !section.instructions[targetIndex]) {
      console.warn("Invalid drag/drop indices");
      return;
    }

    setCurrentData((prevState) =>
      prevState.map((item) =>
        item.id === idid
          ? {
              ...item,
              instructions: reorderArray(item.instructions, draggedItem.current!, targetIndex),
            }
          : item
      )
    );

    draggedItem.current = null;
  };

  const reorderArray = (arr: SectionData["instructions"], fromIndex: number, toIndex: number): SectionData["instructions"] => {
    const updatedArr = [...arr];
    const [movedItem] = updatedArr.splice(fromIndex, 1);
    updatedArr.splice(toIndex, 0, movedItem);
    return updatedArr;
  };

  const handleImageDelete = (id: number, index: number, type: "smallimage" | "bigimage", imageUrl: string) => {
    console.log("oooooosss")
    setImageMap((prev) => {
      const updatedImages = prev[id]?.filter((_, i) => i !== index) || [];
      const remainingImages = updatedImages.map((img) => img.url).join(",");
      updateSectionsData(id, type, imageUrl, true);
      return { ...prev, [id]: updatedImages };
    });
  };

  const handleSmallImageUpload = async (instructionId: number, file: File | null, mainId: number) => {
    if (!file) return;

    console.log("Uploading small image for instruction ID:", instructionId);
    const formData = new FormData();
    formData.append("answer", file);

    try {
      const response = await uploadimagetask(formData, token);
      const uploadedFileName = response.data.answer;
      const imageUrl = response.data.answer;

      console.log(imageUrl, "Received Small Image URL from API");

      if (!imageUrl) return;

      setCurrentData((prevData) =>
        prevData.map((item) =>
          item.id === mainId
            ? {
                ...item,
                instructions: item.instructions.map((inst) =>
                  inst.id === instructionId
                    ? {
                        ...inst,
                        smallimage: inst.smallimage ? `${inst.smallimage},${uploadedFileName}` : uploadedFileName,
                      }
                    : inst
                ),
              }
            : item
        )
      );

      setInstructionImageMap((prev) => [
        ...prev,
        {
          mainId,
          instructionId,
          image: uploadedFileName,
          hint_id:"",
           primarykeyid: 0 
        },
      ]);
    } catch (error) {
      console.error("Error uploading small image:", error);
    }
  };

  const handleSmallImageDelete = (instructionId: number, mainId: number) => {
    console.log(instructionId, mainId, "Deleting small image");

    setInstructionImageMap((prev) =>
      prev.filter((entry) => !(entry.mainId === mainId && entry.instructionId === instructionId))
    );

    setCurrentData((prevData) =>
      prevData.map((item) =>
        item.id === mainId
          ? {
              ...item,
              instructions: item.instructions.map((inst) =>
                inst.id === instructionId ? { ...inst, smallimage: "" } : inst
              ),
            }
          : item
      )
    );
  };
useEffect(() => {
  if (!currentData || currentData.length === 0) return;

  const valueArrayForSection = valueArray.filter((v) => v.mainid === idid);
  const valueHiArrayForSection = valueHiArray.filter((v) => v.mainid === idid);

  const instructionsLength = Math.max(valueArrayForSection.length, valueHiArrayForSection.length, 1);

  setCurrentData((prevState) =>
    prevState.map((section) => {
      if (section.id !== idid) return section;

      // Merge existing instructions
      const updatedInstructions = section.instructions.map((inst, idx) => {
        const enItem = valueArrayForSection.find((v) => v.index === idx + 1);
        const hiItem = valueHiArrayForSection.find((v) => v.index === idx + 1);

        return {
          ...inst, // keep existing fields including primarykeyid
          value: enItem?.value || inst.value || "",
          value_hi: hiItem?.value || inst.value_hi || "",
          hint_id: enItem?.hint_id || hiItem?.hint_id || inst.hint_id || "",
          primarykeyid: inst.primarykeyid || enItem?.primarykeyid || hiItem?.primarykeyid || 0,
        };
      });

      // Append new instructions if valueArray has more items
      const additionalInstructions = Array.from(
        { length: instructionsLength - updatedInstructions.length },
        (_, index) => {
          const enItem = valueArrayForSection.find(
            (v) => v.index === updatedInstructions.length + index + 1
          );
          const hiItem = valueHiArrayForSection.find(
            (v) => v.index === updatedInstructions.length + index + 1
          );

          return {
            id: updatedInstructions.length + index + 1,
            value: enItem?.value || "",
            value_hi: hiItem?.value || "",
            smallimage: "",
            bigimage: "",
            hint_id: enItem?.hint_id || hiItem?.hint_id || "",
            primarykeyid: enItem?.primarykeyid || hiItem?.primarykeyid || 0,
          };
        }
      );

      return {
        ...section,
        instructions: [...updatedInstructions, ...additionalInstructions],
      };
    })
  );
}, [activeStep, idid, valueArray, valueHiArray]);


  console.log(imageMap, "imageMapssssssssssssss");
  console.log(sectionsData, "c");
  console.log(instructionImageMap, "instructionImageMapddddddds");
  console.log(valueHiArray, "valueHiArray333333", valueArray,"instructionImageMapinstructionImageMap",instructionImageMap);

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      <Box className={containerClassName} sx={{ width: "100%", marginLeft: "50px" }}>
        {currentData
          .find((item) => item.id === idid)
          ?.instructions?.map((instruction, indexZeroBased) => {
            const index = indexZeroBased + 1;
            const mainid = currentData.find((item) => item.id === idid)?.id;
  const previewImagesForInstruction = instructionImageMap
      .filter(img => img.mainId === mainid && img.instructionId === instruction.id && img.image)
      .map(img => img.image);
            if (mainid === undefined) return null;
            return (
              <React.Fragment key={instruction.id}>
                <Box
                  draggable
                  onDragStart={() => handleDragStart(index)}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleDrop(index)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "22px",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      cursor: "grabbing",
                      color: "#525252",
                      fontSize: "19px",
                    }}
                  >
                    ⋮⋮
                  </span>

                  <Fileupload
                    fileuploadclass="instruction-upload"
                    iconSrc={galleryadd}
                    onFileSelect={(file) => handleSmallImageUpload(instruction.id, file, idid)}
                    previewSize={{ width: 24, height: 24 }}
                    onRemoveFile={() => handleSmallImageDelete(instruction.id, idid)}
              previewImage={previewImagesForInstruction[0] || ""} 
                  />

                  <TextField
                    sx={{
                      ".MuiInputBase-input": {
                        padding: "16px",
                        color: "#171717",
                        fontSize: "16px",
                        fontWeight: "500",
                        background: "#F9FBFC",
                        borderRadius: "10px",
                        width: "100%",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                    }}
                    id={`Instruction-${instruction.id}`}
                    placeholder={`${placeholderPrefix} ${instruction.id}`}
                    variant="outlined"
                    value={
                      activeStep === 1
                        ? valueArray.find((v) => v.mainid === mainid && v.index === index)?.value || ""
                        : valueHiArray.find((v) => v.mainid === mainid && v.index === index)?.value || ""
                    }
                    onChange={(e) => {
                      const newValue = e.target.value;
                      handleInputChange(mainid, index, newValue);
                    }}
                  />
                  <Tooltip title="Delete" arrow>
                    <Button
                      onClick={() => removeInstruction(instruction.id)}
                      sx={{
                        border: "1px solid #F1F2F3",
                        padding: "16px",
                        borderRadius: "10px",
                        minWidth: "56px",
                        height: "56px",
                        "&:hover": { backgroundColor: "transparent !important" },
                        ".MuiTouchRipple-root": { display: "none" },
                      }}
                    >
                      <img
                        crossOrigin="anonymous"
                        style={{ cursor: "pointer" }}
                        src={trash}
                        alt="trash"
                        height={24}
                        width={24}
                      />
                    </Button>
                  </Tooltip>
                </Box>

                <Box
                  className="showimages"
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginBottom: "22px",
                  }}
                >
                  {imageMap[instruction.id]
                    ?.filter((preview) => preview.type === "bigimage")
                    .map((preview, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "relative",
                          display: "inline-block",
                          minHeight: "unset",
                        }}
                      >
                        <img
                          crossOrigin="anonymous"
                          src={preview.url}
                          alt={`Preview ${index}`}
                          style={{
                            width: "209px",
                            height: "209px",
                            margin: "5px",
                            border: "1px solid #E7E8E9",
                            borderRadius: "12px",
                          }}
                        />
                        <Button
                          onClick={() => handleImageDelete(instruction.id, index, "bigimage", preview.url)}
                          sx={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.10)",
                            width: "24px",
                            height: "24px",
                            minWidth: "unset",
                            padding: "0",
                          }}
                        >
                          <img
                            crossOrigin="anonymous"
                            src={cancel}
                            alt="Delete"
                            style={{ width: "16px", height: "16px" }}
                          />
                        </Button>
                      </Box>
                    ))}
                </Box>
              </React.Fragment>
            );
          }) || null}
        <Button
          onClick={() => addInstruction(idid)}
          sx={{
            padding: "0",
            textTransform: "capitalize",
            fontSize: "14px",
            fontWeight: "500",
            color: "#C8172F",
          }}
        >
          <img crossOrigin="anonymous" style={{ marginRight: "8px" }} src={plus} alt="plus" /> {lang.addInstruction}
        </Button>
      </Box>
    </Box>
  );
};

export default InstructionOne;